import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import './userDetails.css';

class UserDetails extends React.Component {
    constructor(props) {
        super(props);

        this.columns = [{
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
            width: 200
        }, {
            title: 'Last Name',
            dataIndex: 'lastName',
            key: 'lastName',
            width: 200
        }, {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width: 200
        }];

        this.state = {
            rows: [],
            columns: this.columns
        };
    }

    componentDidMount = () => {
        const data= this.props.users || [];
        this.setState({
            rows: data
        });
    }

    render () {
        const { rows, columns } = this.state;

        return (
            <div>
                <Table
                    dataSource={rows}
                    columns={columns}
                    rowKey={'email'}
                    pagination={false}
                    bordered
                    size="small"/>
            </div>
        );
    }
}

export default UserDetails;

UserDetails.propTypes = {
    users: PropTypes.arrayOf(PropTypes.object),
};


// WEBPACK FOOTER //
// ./src/components/UserDetails/index.js